import React from "react";
import Icon from "./ui/Icon";
import { CHANNEL_COUNT } from "../constants/app";
import DialogModal from "./overlays/DialogModal";

export default function AutoCreatePrompt({ node, onConfirm, onDecline, isOpen, ewlCount = 1 }) {
  const [count, setCount] = React.useState(CHANNEL_COUNT);

  if (!node) return null;

  return (
    <DialogModal isOpen={isOpen}>
      <div className="w-full max-w-sm rounded-2xl border border-brand-purple bg-brand-navy p-4 space-y-4 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-purple text-brand-magenta">
            <Icon name="bolt" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-brand-light">Create channels</span>
            <span className="text-[11px] text-brand-light/50">
              Found {ewlCount} EWL-810{ewlCount > 1 ? "s" : ""}. Create channels for{" "}
              {node.name || node.id}?
            </span>
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-[11px] text-brand-light/70">Channels for this EWL</label>
          <select
            value={count}
            onChange={(e) => setCount(Number(e.target.value))}
            className="w-full rounded-lg border border-brand-purple bg-brand-navy px-3 py-2 text-sm text-brand-light focus:outline-none focus:ring-1 focus:ring-brand-magenta"
          >
            {[...Array(CHANNEL_COUNT)].map((_, idx) => (
              <option key={idx + 1} value={idx + 1}>
                {idx + 1} channel{idx === 0 ? "" : "s"}
              </option>
            ))}
          </select>
          <p className="text-[11px] text-brand-light/50">
            Channels are created on {node.name || node.id} with defaults (dimming, no delays).
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => onConfirm(node.id, node.name, count)}
            className="w-full rounded-xl bg-brand-magenta px-4 py-2 text-sm font-semibold text-white hover:bg-brand-pink transition"
          >
            Create channels
          </button>
          <button
            type="button"
            onClick={() => onDecline(node.id)}
            className="w-full rounded-xl border border-brand-purple bg-brand-purple px-4 py-2 text-sm font-semibold text-brand-light hover:border-brand-magenta transition"
          >
            Skip this EWL
          </button>
        </div>
      </div>
    </DialogModal>
  );
}
